export default "__VITE_ASSET__c1619b55__"